<template>
  <div class="share-account-access" v-if="setupUrl">
    <button
      v-if="hasShareApi"
      class="share-account-access--share-button button"
      @click="share"
    >
      {{ $t("share-button-label") }}
    </button>
    <div class="field">
      <label class="label">
        {{ $t("share-copypaste-label") }}
      </label>
      <div class="control">
        <input
          v-if="!hasShareApi"
          :value="setupUrl"
          class="input share-account-access--copy-text"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

const strToHex = function (str) {
  var hex = "";
  for (var i = 0; i < str.length; i++) {
    hex += "" + str.charCodeAt(i).toString(16);
  }
  return hex;
};

export default Vue.extend({
  name: "ShareAccountAccess",
  computed: {
    setupUrl() {
      const accountComponentsRegex = new RegExp(
        "https://([a-zA-Z0-9]+):([a-zA-Z0-9]+)@[a-z-.]+/userdb-([a-z0-9]+)$"
      );
      const matches = this.$store.state.dbUrl.match(accountComponentsRegex);

      if (!matches || matches.length !== 4) {
        return null;
      }

      const account = matches[1];
      const secret = matches[2];
      const dbName = matches[3];

      if (strToHex(account) !== dbName) {
        return null;
      }

      return `https://meal-planner.pixelistik.de/#/settings?setAccount=${account}&setSecret=${secret}`;
    },
    hasShareApi: function () {
      return "share" in navigator;
    },
  },
  methods: {
    share: function () {
      navigator.share({
        title: this.$t("share-title"),
        text: this.$t("share-text"),
        url: this.setupUrl,
      });
    },
  },
});
</script>
<i18n>
{
  "en": {
    "share-button-label": "Share access to your list",
    "share-copypaste-label": "Share access to your list with this URL",
    "share-title": "Meal Planner",
    "share-text": "Access to shopping list"
  },
  "de": {
    "share-button-label": "Teile den Zugriff auf deine Liste",
    "share-copypaste-label": "Teile den Zugriff auf deine Liste mit dieser URL",
    "share-title": "Meal Planner",
    "share-text": "Zugriff auf die Einkaufsliste"
  }
}
</i18n>
